"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Calendar;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Calendar(props) {
  var monthDate = props.monthDate,
      onSelect = props.onSelect,
      startDate = props.startDate,
      endDate = props.endDate,
      isInvalidDate = props.isInvalidDate;
  var numMonth = monthDate.getMonth();
  var monthName = (0, _helpers.getAbbreviatedMonthName)(numMonth);
  var year = monthDate.getFullYear();
  var numFirstDay = (0, _helpers.getNumFirstDay)(year, numMonth);
  var blanksTds = [];

  for (var i = 0; i < numFirstDay; i++) {
    blanksTds.push(_react["default"].createElement("td", {
      className: "calendar-day"
    }));
  }

  var numDaysInAMonth = (0, _helpers.getNumDaysInAMonth)(year, numMonth);
  var isDateInBetweenStartAndEndDate = startDate && endDate && (0, _helpers.isDateInRange)(startDate, endDate);
  var daysInMonthTds = [];

  var _loop = function _loop(day) {
    var dateObj = new Date(year, numMonth, day);
    var classNames = ['calendar__date'];
    var inRange = isDateInBetweenStartAndEndDate && isDateInBetweenStartAndEndDate(dateObj);
    if (inRange) classNames.push('date_range');
    var isDate = (0, _helpers.isSameDate)(dateObj);
    if (isDate(startDate)) classNames.push('start_date');
    if (isDate(endDate)) classNames.push('end_date');
    var isDisabled = (0, _helpers.isDateBeforeToday)(dateObj) || isInvalidDate && isInvalidDate(dateObj);
    if (isDisabled) classNames.push('disabled');
    daysInMonthTds.push(_react["default"].createElement("td", {
      key: day,
      className: classNames.join(' '),
      onClick: function onClick() {
        return !isDisabled && onSelect(dateObj);
      }
    }, day));
  };

  for (var day = 1; day <= numDaysInAMonth; day++) {
    _loop(day);
  }

  var totalDaysInMonths = [].concat(blanksTds, daysInMonthTds);
  var rows = constructWeekRowAndDayCells(totalDaysInMonths);
  return _react["default"].createElement("div", {
    className: "calendar__wrapper calendar__month"
  }, _react["default"].createElement("div", {
    className: "calendar__month_name"
  }, monthName, " ", year), _react["default"].createElement("table", {
    className: "calendar__dates"
  }, _react["default"].createElement("tbody", null, rows.map(function (numDay) {
    return _react["default"].createElement("tr", null, numDay);
  }))));
}

function constructWeekRowAndDayCells(totalDaysInMonths) {
  var rows = [],
      cells = [];
  totalDaysInMonths.forEach(function (row, i) {
    if (i % 7 !== 0) {
      // if index not equal 7 that means not go to next week
      cells.push(row);
    } else {
      // when reach next week we contain all td in last week to rows
      rows.push(cells); // empty container

      cells = []; // in current loop we still push current row to new container

      cells.push(row);
    } // when end loop we add remain date


    if (i === totalDaysInMonths.length - 1) rows.push(cells);
  });
  return rows;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@honeyguide/components/dist/components/DateRangePicker/Calendar.js
// module id = 732
// module chunks = 2